(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');

  const initialize = (root = document) => {
    root.querySelectorAll('.sila-image-hero-block__media--parallax[data-parallax-background]').forEach((media) => {
      if (media.dataset.parallaxInitialized === 'true') return;
      media.dataset.parallaxInitialized = 'true';

      const url = media.dataset.parallaxBackground;
      const layer = media.querySelector('.sila-image-hero-block__fixed-background');
      if (!url || !layer) return;

      const preload = new Image();
      preload.onload = () => {
        layer.style.backgroundImage = `url("${url.replace(/"/g, '\\"')}")`;
        if (desktopQuery.matches) media.classList.add('is-parallax-ready');
      };
      preload.onerror = () => media.classList.remove('is-parallax-ready');
      preload.src = url;
    });
  };

  const syncMode = () => {
    document.querySelectorAll('.sila-image-hero-block__media--parallax').forEach((media) => {
      const layer = media.querySelector('.sila-image-hero-block__fixed-background');
      media.classList.toggle('is-parallax-ready', desktopQuery.matches && Boolean(layer?.style.backgroundImage));
    });
  };

  initialize();
  desktopQuery.addEventListener?.('change', syncMode);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
